import { Api } from 'utils';

class ClientQuoteService {
	
	static client = {
		get: async (params?: any) => Api.createResponse('client/quotes/get',params),
		getQuote: async (params?: any) => Api.createResponse('client/quotes/get-quote',params),
		getJourneys: async (params?: any) => Api.createResponse('client/quotes/get-journeys',params),
		cancelQuote: async (params?: any) => Api.createResponse('client/quotes/cancel-quote',params),
		getQuotesMonth: async (params?: any) => Api.createResponse('client/quotes/get-quotes-month',params),
		getBanks: async (params?: any) => Api.createResponse('client/quotes/get-banks',params),
		getServices: async (params?: any) => Api.createResponse('client/quotes/services',params),
		viewService: async (params?: any) => Api.createResponse('client/quotes/view-service',params),
		create: async (params?: any) => Api.createResponse('client/quotes/create',params),
		download: async (params?: any) => Api.createResponse('client/quotes/download',params),
		getHolidays: async (params?: any) => Api.createResponse('client/quotes/get-holidays',params),
		editDate: async (params?: any) => Api.createResponse('client/quotes/edit-date',params),
		checkDiscountCode: async (params?: any) => Api.createResponse('client/quotes/check-discount-code',params),
		getLastFinished: async (params?: any) => Api.createResponse('client/quotes/get-last-finished',params),
	}

}

export default ClientQuoteService;